// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getFlagshipStoreApi } from "../../services/Api/FlagshipStoreApi"
import { getErrors, getFlagshipStoresSuccess } from "../reducers/FlagshipStoreReducer"

// Watchers
function* flagshipStoreSaga() {
	yield takeEvery("flagship_stores/getFlagshipStores", getFlagshipStore)
}

// Sagas
function* getFlagshipStore(action) {
	// console.log(action.payload, "flagship store payload")
	try {
		const getFlagship_stores = yield call(getFlagshipStoreApi, action.payload)
		// console.log(getFlagship_stores, "banner saga response")

		if (getFlagship_stores.request.status == 200) {
			yield put(getFlagshipStoresSuccess(getFlagship_stores))
		} else {
			yield put(getErrors(true))
		}
	} catch (error) {
		// console.log(error,"otp error")
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(flagshipStoreSaga)])
}
